import { Box, HStack, Heading, Text, Spacer } from "@chakra-ui/react";

const PageHeader = ({ title, subtitle, right }) => (
  <Box
    bgGradient="linear(to-r, green.800, green.600)"
    color="white"
    borderRadius="xl"
    px={6}
    py={5}
    mt={6}
    mb={6}
    boxShadow="md"
  >
    <HStack>
      <Box>
        <Heading size="md">{title}</Heading>
        {subtitle && (
          <Text opacity={0.85} fontSize="sm">
            {subtitle}
          </Text>
        )}
      </Box>
      <Spacer />
      {right}
    </HStack>
  </Box>
);

export default PageHeader;
